export const colorCharts = [
  "paletteBarChart1",
  "paletteBarChart2",
  "paletteBarChart3",
  "paletteBarChart4",
  "paletteBarChart5",
  "paletteBarChart6",
  "paletteBarChart7",
  "paletteBarChart8",
  "paletteBarChart9",
  "paletteBarChart10",
  "paletteBarChart11",
  "paletteBarChart12",
  "paletteBarChart13",
  "paletteBarChart14",
  "paletteBarChart15",
];
